<template>
    <ui-modal title="Dados do Formulário" icon="fal fa-credit-card-front" name="marketing-queues-form-data" size="sm">
        <div class="form-data">
            <div class="title">Escolha uma opção para utilizar o formulário:</div>

            <div class="label">Link do Formulário:</div>
            <div class="input-group button-group">
                <ui-code :copy="doCopyURL">{{ makeUrl }}</ui-code>
                <button class="button link" type="button" @click="previewLink">Visualizar</button>
                <button class="button" type="button" @click="copyURL">Copiar</button>
            </div>

            <div class="label">Código para Incorporação:</div>
            <div class="input-group button-group">
                <ui-code :copy="doCopy">
                    &lt;script&gt;{{ iframe }}&lt;/script&gt;
                </ui-code>
                <button class="button" type="button" @click="copyCode">Copiar</button>
            </div>
        </div>
    </ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiCode } from '@/components/ui'

	import { storage } from '@/services/storage'

	export default {
		name: 'ui-form-data-modal',
		components: {
			uiModal,
			uiCode,
		},

		data() {
			return {
				apiConfig: JSON.parse(storage.get('api_config')),
				id: null,
				doCopyURL: false,
				doCopy: false,
			}
		},

		computed: {
			makeUrl() {
				let hash = btoa(`${this.apiConfig.instance}-${this.id}`)
				let cleanHash = hash.replace(/=/g, '')
				let arrayHash = cleanHash.split('')
				let invertedString = arrayHash[arrayHash.length - 1]

				for (let i = 1; i < arrayHash.length; i++) {
					invertedString += arrayHash[i]

					if (i == arrayHash.length - 2) {
						invertedString += arrayHash[0]
						break
					}
				}

				return (
					(this.apiConfig.environment == 'portainer' || this.apiConfig.environment == 'local'
						? 'http://'
						: 'https://') +
					window.location.host + this.$router.options.base + 'form-public/' + invertedString
				)
			},

			iframe() {
				return `<iframe src="${this.makeUrl}" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`
			},
		},

		mounted() {
			this.$root.$on('modal-open-marketing-queues-form-data', (data) => {
				this.id = data
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-marketing-queues-form-data')
		},

		methods: {
			previewLink() {
				window.open(this.makeUrl, 'blank')
			},
			
			copyURL() {
				this.doCopyURL = true

				setTimeout(() => {
                    this.doCopyURL = false
                }, 3000)
			},

			copyCode() {
				this.doCopy = true
				
				setTimeout(() => {
                    this.doCopy = false
                }, 3000)
			},
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
